import Link from "@casino/client/components/Link";
import ProviderTileGames from "./ProviderTileGames";
import ProviderTileLogo from "./ProviderTileLogo";

type Props = {
  provider: ProviderTileData;
  gamesCountLabel: string;
  colorScheme: ColorScheme;
};

const ProviderTile: FC<Props> = ({
  provider,
  gamesCountLabel,
  colorScheme,
}) => (
  <div
    data-slot="provider-tile"
    data-testid={`provider-tile-${provider.handle}`}
    className="group relative aspect-square overflow-hidden rounded-2xl bg-secondary transition-shadow hover:shadow-lg"
  >
    <Link prefetch={false} href={provider.href} className="absolute inset-0">
      <ProviderTileGames games={provider.games} />
      <span
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 block h-[44%] bg-linear-to-t from-background from-0% via-background/85 via-25% to-transparent to-56%"
      />
      <span
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 block h-[44%] bg-linear-to-t from-background from-0% via-background/85 via-25% to-transparent to-56%"
      />
      <span className="absolute inset-x-3 grid h-16 place-items-center">
        <ProviderTileLogo
          src={provider.logoUrl}
          name={provider.name}
          colorScheme={colorScheme}
        />
      </span>
      <span className="absolute inset-x-3 bottom-3 block text-center text-xs text-muted-foreground">
        {gamesCountLabel}
      </span>
    </Link>
  </div>
);

export default ProviderTile;
